import { useContext, useEffect } from "react";

import { MktgDataContext } from "@swa-ui/application";
import { useLocation } from "@swa-ui/browser";
import { swaDate } from "@swa-ui/date";

import { getTripType } from "../utils";
import {
  getBookingCurveDetails,
  getProductString,
  getSeatProducts,
  getTargetSeatString,
  getTimeToDeparture,
} from "./airSeatsHelperUtils";
import { AIR_SEATS_ROUTES } from "./defines/airSeatRoutes";

export function usePurchaseSeatsAnalytics({
  airReservation,
  allPassengersSeatDetails,
  fareDetails,
  rrChaseCardType,
  seatMapData,
}) {
  const { pathname } = useLocation();
  const { setMktgPageData } = useContext(MktgDataContext);
  const { bounds, passengers, tripType, id } = airReservation;
  const tempNewAirReservation = {
    ...airReservation,
    seats: seatMapData.seats,
  };

  useEffect(() => {
    if (pathname === AIR_SEATS_ROUTES.purchase) {
      setMktgPageData(
        {
          ...getBoundSpecificDetails(),
          air_confirmationnumber: id,
          bound_seat: getTargetSeatString(allPassengersSeatDetails),
          number_passengers: `${passengers?.length}`,
          productarray: getSeatProducts(tempNewAirReservation, tripType, true),
          revenuestream: "seats",
          rrchasecardtype: rrChaseCardType ?? "",
          sccheckout: "1",
          seatcredit: `${fareDetails?.totalCredit}`,
          seatprice: `${fareDetails?.totalFare}`,
          seatproduct: getProductString(getSeatProducts(tempNewAirReservation, tripType, true)),
          seatsstandalone: "1",
          triptype: getTripType(tripType),
        },
        "purchaseSeats"
      );
    }
  }, [allPassengersSeatDetails, fareDetails, rrChaseCardType]);

  function getBoundSpecificDetails() {
    const boundSpecificDetails = {
      air_bound1_airportcode: "",
      air_bound1_date: "",
      air_bound1_selectedfaretype: "",
      air_bound2_airportcode: "",
      air_bound2_date: "",
      air_bound2_selectedfaretype: "",
      bookingcurve: "",
      segments: 0,
      timetodeparture: "",
    };
    let totalSegments = 0;

    bounds.forEach((bound, index) => {
      const { segments } = bound;
      const boundIndex = index + 1;
      const segmentlength = segments?.length;

      const timetoDepart = swaDate(segments[0]?.departure?.scheduledAt).diff(swaDate(), "minutes");
      const departWithInTwoDays = timetoDepart <= 2880 ? true : false;

      totalSegments += segmentlength;

      if (!bound.flown) {
        boundSpecificDetails[`air_bound${boundIndex}_airportcode`] = `${
          segments[0]?.departure?.airport
        }:${segments?.[segmentlength - 1]?.arrival?.airport}`;
        boundSpecificDetails[`air_bound${boundIndex}_date`] = swaDate(
          segments[0]?.departure?.scheduledAt
        ).format("YYYY-MM-DD");
        boundSpecificDetails[`air_bound${boundIndex}_selectedfaretype`] = segments[0]?.fareFamily;
        boundSpecificDetails[`bookingcurve`] = getBookingCurveDetails(
          segments[0]?.departure?.scheduledAt
        );
        boundSpecificDetails[`segments`] = totalSegments.toString();

        if (timetoDepart > 0 && departWithInTwoDays) {
          boundSpecificDetails[`timetodeparture`] = getTimeToDeparture(
            segments[0]?.departure?.scheduledAt
          );
        }
      }
    });

    return boundSpecificDetails;
  }
}
